const _ = require('lodash');

const DEFAULT_DURATION_MS = 60 * 60 * 1000;

// The admin editor, the Zoom image frames and the API normalizer all read these, so the limits can't drift.
const KEY_TAKEAWAY_MAX = 4;
const KEY_TAKEAWAY_MAX_CHARS = 120;
const EVENT_OVERVIEW_MAX_CHARS = 240;

// maxLength only stops new typing, so copy entered before a lead can still push the pair past the limit.
const isTakeawayOverLimit = ({ lead = '', copy = '' }) => lead.trim().length + copy.trim().length > KEY_TAKEAWAY_MAX_CHARS;

// The admin Zoom card and the live card both strip this prefix. One copy, so they can't drift.
const getEpisodeTitle = (title, speakerName) => {
  if (!speakerName) return title || '';
  return String(title || '').replace(new RegExp(`^in conversation with ${_.escapeRegExp(speakerName)}\\s*[:—–-]\\s*`, 'i'), '');
};

// The single place a webinar's lifecycle is decided — imported by the public API that
// filters on it and by the card that renders from it. Derived, never stored, so it
// cannot go stale and no cron has to advance it.
const getWebinarCardState = webinar => {
  const startsAt = webinar.startsAt && new Date(webinar.startsAt);
  if (!startsAt) return 'past';
  const endsAt = webinar.endsAt ? new Date(webinar.endsAt) : new Date(startsAt.getTime() + DEFAULT_DURATION_MS);
  const now = new Date();
  if (now < startsAt) return 'upcoming';
  if (now <= endsAt) return 'live';
  if (!webinar.replayUrl) return 'awaiting_replay';
  return 'past';
};

module.exports = { getWebinarCardState, getEpisodeTitle, isTakeawayOverLimit, KEY_TAKEAWAY_MAX, KEY_TAKEAWAY_MAX_CHARS, EVENT_OVERVIEW_MAX_CHARS };
